import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.VUE_APP_ApplicationInsights_ConnectionString,
    autoTrackPageVisitTime: true,
    enableAutoRouteTracking: true,
    enableAjaxPerfTracking: true,
    enableCorsCorrelation: true,
    correlationHeaderExcludedDomains: [
      "www.google-analytics.com",
      "www.facebook.com",
      "web.facebook.com",
      "api-js.mixpanel.com",
      "stats.g.doubleclick.net",
      "api-iam.intercom.io",
      "peaknotification-sit.azurewebsites.net",
      "peaknotification-uat.azurewebsites.net",
      "peaknotification-staging.azurewebsites.net",
      "peaknotification-production-staging.azurewebsites.net",
      "peaknotification-production.azurewebsites.net",
      "peak-featureflag-sit.azconfig.io",
      "peak-featureflag-uat.azconfig.io",
      "peak-featureflag-staging.azconfig.io",
      "peak-featureflag-prod.azconfig.io",
    ],
    enableRequestHeaderTracking: true,
    enableAjaxErrorStatusText: true,
  },
});
export default appInsights;
